/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type FollowSearchButton_favoritesConnection$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespNotListedContent_user$ref: FragmentReference;
export type PdpRespNotListedContent_user = {|
  +serviceId: ?string,
  +favorites?: ?{|
    +$fragmentRefs: FollowSearchButton_favoritesConnection$ref
  |},
  +$refType: PdpRespNotListedContent_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespNotListedContent_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "followSearchPages",
      "type": "[String]"
    },
    {
      "kind": "RootArgument",
      "name": "fetchFollowSearch",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchFollowSearch",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "favorites",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1,
              "type": "Int"
            },
            {
              "kind": "Variable",
              "name": "pages",
              "variableName": "followSearchPages",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "types",
              "value": [
                "SEARCH"
              ],
              "type": "[types]"
            }
          ],
          "concreteType": "favoritesConnection",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "FollowSearchButton_favoritesConnection",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f7a9f85b01f8a43dd40044c7aa4da63f';
module.exports = node;
